
const accordion = () => {
	let acc = document.getElementsByClassName("accordion");

	//if no accordion
	if (!acc.length) return;

	for (let i = 0; i < acc.length; i++) {
		let title = acc[i].querySelector(".accordion__title");
		title.addEventListener("click", function () {
			this.parentNode.classList.toggle("active");
			let panel = this.nextElementSibling;

			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}

		});
	}
};
export default accordion;
